import React from 'react';

function AnimatedBackground({ imageUrl, opacity = 0.3 }) {
  return (
    <>
      {/* Animated Background Image */}
      <div
        className="fixed inset-0 z-0 bg-cover bg-center transition-all duration-1000"
        style={{
          backgroundImage: `url("${imageUrl}")`,
          backgroundSize: '120% 120%',
          opacity: opacity,
          animation: 'pan 30s linear infinite'
        }}
      />

      {/* Gradient Overlay */}
      <div className="fixed inset-0 bg-gradient-to-t from-[#020403] via-[#020403]/50 to-[#020403] z-0" />

      {/* Cyber Grid Pattern */}
      <div
        className="fixed inset-0 z-0 opacity-20 pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(rgba(0,243,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0,243,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px'
        }}
      />

      {/* Floating Code Elements */}
      <div className="fixed inset-0 z-0 opacity-20 pointer-events-none overflow-hidden">
        <div className="absolute top-10 left-[10%] text-green-500/20 text-xs animate-pulse font-mono">0101010100101...</div>
        <div className="absolute top-40 right-[15%] text-blue-400/20 text-xs animate-pulse font-mono">SYSTEM_ACTIVE...</div>
        <div className="absolute bottom-20 left-[5%] text-pink-500/20 text-xs animate-pulse font-mono">PROCESSING...</div>
      </div>
    </>
  );
}

export default AnimatedBackground;
